import React, { Component } from "react"
import { Button, FormControl } from "react-bootstrap"
import DatePicker from "../../../../../components/common/DatePicker"
import "./NewMaintenance.css"

interface NewMaintenanceProps {
    maintenanceTypeList: Array<any>
    isChrome: boolean
    appendServiceParams: Function
    handleMaintenanceDate: Function
    maintenanceDate: number
    setEventType: Function
    Mileage: any
    handleChange: any
    PerformedBy: string
    PurchaseOrderNumber: string
    Comments: string
    toggleNewRecieptView: Function
    // updateMaintenanceItems: Function
    addNewMaintenance: Function
    serviceParams: Array<any>
    toggleNewMaintenanceView: Function
}

class NewMaintenance extends Component<NewMaintenanceProps> {

    addMaintenance = () => {
        // this.props.updateMaintenanceItems(true)
        this.props.addNewMaintenance()
        // this.props.toggleNewMaintenanceView()
    }

    render() {

        return (
            <div className="NewMaintenance">
                <div className="VM-New-Maintenance-Columns">
                    <div className="VM-New-Maintenance-C1">
                        <div className="Vehicle-Maintenance-Service-Types-Wrapper">
                            {this.props.maintenanceTypeList.length > 0 && this.props.maintenanceTypeList.map((maintenanceItem, i) =>
                                <div key={"vehcile-maintenance-services-type-" + maintenanceItem.id}>
                                    {!maintenanceItem.checked && <Button onClick={() => this.props.appendServiceParams(maintenanceItem, i, true)}>
                                        <div id="vehicle-maintenance-service-type-btn">
                                            {this.props.isChrome && <input id="fleet-chrome-radio" type="checkbox" onClick={() => this.props.appendServiceParams(maintenanceItem, i, true)}></input>}
                                            {!this.props.isChrome && <input id="fleet-fox-radio" type="checkbox" onClick={() => this.props.appendServiceParams(maintenanceItem, i, true)}></input>}
                                            <p>{maintenanceItem.text}</p>
                                        </div>
                                    </Button>}
                                    {maintenanceItem.checked && <Button id="vas-ranges-clear" onClick={() => this.props.appendServiceParams(maintenanceItem, i, false)}>
                                        <div id="vehicle-maintenance-service-type-btn">
                                            {this.props.isChrome && <input id="fleet-chrome-radio" type="checkbox" defaultChecked onClick={() => this.props.appendServiceParams(maintenanceItem, i, false)}></input>}
                                            {!this.props.isChrome && <input id="fleet-fox-radio" type="checkbox" defaultChecked onClick={() => this.props.appendServiceParams(maintenanceItem, i, false)}></input>}
                                            <p>{maintenanceItem.text}</p>
                                        </div>
                                    </Button>}
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="VM-New-Maintenance-C2">
                        <p>Maintenance Date</p>
                        <DatePicker value={this.props.maintenanceDate} onChange={this.props.handleMaintenanceDate} type="input" useCloseCallback />
                        <p>Mileage</p>
                        <FormControl
                            onFocus={() => this.props.setEventType("Mileage")}
                            placeholder={this.props.Mileage + "" || "Vehicle Mileage"}
                            aria-describedby="basic-addon1"
                            onChange={this.props.handleChange}
                            value={this.props.Mileage || ""}
                        />
                        <p>Business Performing Work</p>
                        <FormControl
                            onFocus={() => this.props.setEventType("PerformedBy")}
                            placeholder={this.props.PerformedBy + "" || "Performed By"}
                            aria-describedby="basic-addon1"
                            onChange={this.props.handleChange}
                            value={this.props.PerformedBy || ""}
                        />
                        <p>Purchase Order Number</p>
                        <FormControl
                            onFocus={() => this.props.setEventType("PurchaseOrderNumber")}
                            placeholder={this.props.PurchaseOrderNumber + "" || "Order #"}
                            aria-describedby="basic-addon1"
                            onChange={this.props.handleChange}
                            value={this.props.PurchaseOrderNumber || ""}
                        />
                    </div>
                    <div className="VM-New-Maintenance-C3">
                        <p>Comments</p>
                        <FormControl
                            as="textarea"
                            rows={4}
                            onFocus={() => this.props.setEventType("Comments")}
                            placeholder={this.props.Comments + "" || "Comments"}
                            aria-describedby="basic-addon1"
                            onChange={this.props.handleChange}
                            value={this.props.Comments || ""}
                        />
                        {/* <div className="VM-Attach-Receipts-Wrapper">
                            <OverlayTrigger trigger={["hover", "focus"]} placement="auto-end" overlay={receiptTootip}>
                                <span className="material-icons" onClick={() => this.props.toggleNewRecieptView()}>receipt</span>
                            </OverlayTrigger>
                        </div> */}
                    </div>
                </div>
                <div className="VM-New-Maintenance-Footer">
                    {this.props.serviceParams.length > 0 &&
                        this.props.Mileage > 0 &&
                        this.props.PerformedBy !== "" &&
                        this.props.maintenanceDate !== 0 &&
                        <Button id="vm-new-maintenance-save-btn" variant="primary" onClick={() => this.addMaintenance()}>Next</Button>}
                    <Button id="vm-new-maintenance-cancel-btn" variant="secondary" onClick={() => this.props.toggleNewMaintenanceView()}>Cancel</Button>
                </div>
            </div>
        )
    }
}

export default NewMaintenance